export const ETH_LATAM_2024_EVENT_ID = "be4dbf9c-abc9-4bc2-a731-3464b84ce3fb";
